<div
  class="w-full search-containers flex items-center justify-between"
  [ngClass]="{ 'p-0': isInputFullWidth, 'pr-0': isbalanceSheetOwner || isBalanceSheetMember, 'bg-transparent': isAccessManager }"
>
  <div class="form-group form-main form-group-overrides w-full mb-0">
    <div class="div-group w-full">
      <mat-form-field
        id="access-manager-matAutoComplete"
        matTooltipClass="add-member-tooltip"
        [ngClass]="{
          'disable-search': disableSearch,
          'white-background': isInputFocused,
          'temp-alignment': !isInputFocused,
          'w-full': isInputFullWidth,
          'shadow-white-background-input': isWhiteBackgroundInput,
          'max-w-full': isAccessManager || isInputFullWidth
        }"
      >
        <div matPrefix class="ml-3 mr-2 matPrefix-search-icon">
          <img src="../../../../assets/images/search-blue.svg" width="20px" height="19px" />
        </div>

        <input
          type="text"
          matInput
          aria-label="Number"
          [disabled]="disableSearch"
          [formControl]="connectionUserFormControl"
          [matAutocomplete]="auto"
          (input)="onMemberSearch($event.target.value)"
          [placeholder]="placeHolder"
          class="addMember global-input text-base font-sans font-normal"
          [ngClass]="{ 'text-[#53565B66]': disableSearch }"
          #inputField
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          [readonly]="disableSearch"
        />

        @if (connectionUserFormControl.value && !isComboInput) {
        <div matSuffix (click)="onClearInput()">
          <mat-icon class="close-input-icon mr-4">close</mat-icon>
        </div>
        } @if (isInputFocused && isComboInput) {
        <div matSuffix (click)="onClearInput()">
          <mat-icon class="close-input-icon mr-4">close</mat-icon>
        </div>
        }

        <mat-autocomplete #auto="matAutocomplete" class="search-scroll-main template-Search">
          <div>
            <ng-container>
              <div class="w-full">
                @if ((data | addFilterUserDataList : selectedUsers:connectionUserFormControl.value : ignoreProfessional)?.length == 0) {
                <mat-option class="h-fit">
                  <div class="flex gap-4 py-5 h-fit items-center">
                    <div class="flex" style="height: 84px; width: 84px">
                      <img src="assets/images/no-matchin-result.svg" />
                    </div>
                    <div>
                      <div class="font-semibold text-[#18191C]" style="font-size: 22px; margin-bottom: 8px; line-height: 24px">
                        No matching results to show
                      </div>
                      <div class="text-sm font-normal text-[#18191C]">Try changing the search terms, or create a new user</div>
                    </div>
                  </div>
                </mat-option>
                }
                <div class="search-box-container">
                  @if ( (data | addFilterUserDataList : selectedUsers:connectionUserFormControl.value : ignoreProfessional)?.length !== 0) {
                  <div class="grid grid-cols-5 gap-2 px-4 pt-4 pb-3">
                    @for (user of data | addFilterUserDataList : selectedUsers:connectionUserFormControl.value : ignoreProfessional |
                    slice:0:handleReturnSliceListCount() ; track user) {
                    <mat-option
                      class="search-content-box flex-col items-center title option-mobile justify-center"
                      (onSelectionChange)="selectUser(user)"
                    >
                      <div>
                        @if (user?.name) { @if (!user?.isGroup) {
                        <ngx-avatars
                          size="45"
                          src="{{ user?.user_profile_image_url }}"
                          name="{{ user?.nick_name ?? user?.name }}"
                          [round]="true"
                          initialsSize="2"
                          class="flex-center"
                        ></ngx-avatars>
                        } @if (user?.isGroup) {
                        <div>
                          <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                        </div>
                        } } @if (!user?.name) { @if (user?.user_first_middle_name && !user?.isGroup) {
                        <ngx-avatars
                          size="45"
                          src="{{ user?.user_profile_image_url }}"
                          name="{{ user?.nick_name ?? user?.user_first_middle_name + ' ' + user?.user_last_name }}"
                          [round]="true"
                          initialsSize="2"
                          class="flex-center"
                        ></ngx-avatars>
                        } @if (user?.first_middle_name && !user?.isGroup) {
                        <ngx-avatars
                          size="45"
                          src="{{ user?.profile_image_url }}"
                          name="{{ user?.nick_name ?? user?.first_middle_name + ' ' + user?.last_name }}"
                          [round]="true"
                          initialsSize="2"
                          class="flex-center"
                        ></ngx-avatars>
                        } @if (user?.memberUser) {
                        <ngx-avatars
                          size="45"
                          src="{{ user?.memberUser?.profile_image_url }}"
                          name="{{ user?.memberUser | userName }}"
                          [round]="true"
                          initialsSize="2"
                          class="flex-center"
                        ></ngx-avatars>
                        } @if (user?.isGroup) {
                        <div>
                          <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                        </div>
                        } }
                      </div>
                      <div class="txt-center">
                        @if (user?.user_first_middle_name && !user?.isGroup) {
                        <div class="user-text font-semibold">
                          {{ user?.nick_name ?? user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
                          <span>{{ user?.relationship_name }}</span>
                        </div>
                        } @if (user?.user_first_middle_name && user?.isGroup) {
                        <div class="user-text font-semibold">
                          {{ user?.nick_name ?? user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
                        </div>
                        } @if (user?.first_middle_name) {
                        <div class="user-text font-semibold">
                          {{ user?.nick_name ?? user?.first_middle_name + ' ' + user?.last_name | capitalizeRomanNumerals }}
                          <span>{{ user?.relationship_name }}</span>
                        </div>
                        } @if (user?.name) {
                        <div class="user-text font-semibold">
                          {{ user?.name ?? user?.nick_name | capitalizeRomanNumerals }}
                        </div>
                        } @if(user?.memberUser){
                        <div class="user-text font-semibold">
                          {{ user?.memberUser | userName | capitalizeRomanNumerals }}
                        </div>
                        }
                      </div>
                    </mat-option>
                    }
                  </div>
                  } @if (isShowFooter) {
                  <div [ngClass]="{ 'grid grid-cols-2': isShowCreateNewUser && isShowGlobalSearch, 'footer-container gap-3 p-4': true }">
                    @if (isShowCreateNewUser) {
                    <mat-option class="footer-menu" (click)="openInvite()">
                      <div class="flex-center">
                        <img height="h-[33px]" src="assets/images/footer-new-user.svg" />
                      </div>
                      <div class="flex-center template-text mt-1">{{ isManageGuardian ? 'Invite User' : 'Create New User' }}</div>
                    </mat-option>
                    } @if (isShowGlobalSearch) {
                    <mat-option class="footer-menu" (click)="addExistingUsers()">
                      <div class="flex-center">
                        <img height="h-[33px]" src="assets/images/footer-global-search.svg" />
                      </div>
                      <div class="flex-center template-text mt-1">Global User Search</div>
                    </mat-option>
                    }
                  </div>
                  }
                </div>
              </div>

              <!-- *ngIf="loader$ | async" -->
              @if (loader) {
              <mat-option class="h-fit">
                <div class="search-box-container">
                  <div class="loader-container grid grid-cols-7 p-4 pb-0">
                    <!-- @for (item of loaderItems; track item) {
                          <div class="w-full">
                            <div class="w-full" id="{{ item.id }}">
                              <div class="ph-item w-full content__loader"
                                style="padding: 0px; margin: 0px; border: none;">
                                <div class="ph-col-12" style="padding: 0px !important;margin: 0px">
                                  <div class="ph-row">
                                    <div class="ph-col-12" style="height: 96px; border-radius: 4px; max-width: 100px">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        } -->
                  </div>
                  <hr style="margin: 0px" />
                </div>
              </mat-option>
              }
            </ng-container>
          </div>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</div>
